import { getCurrentInstance } from '@vue/composition-api';

export const useRouterQuery = () => {
  const instance = getCurrentInstance().proxy;
  const { $route } = instance;
  return $route.query;
};
